import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {Trans} from '@lingui/macro'
import {Alert} from 'components/UI/Alert/Alert'
import {getColor} from 'components/utils'
import {Button} from 'components/UI/Button/Button'
import {IdRefundsState} from 'model/dashboardRefunds/dRefundsReducer';
import {
    ClipboardListIcon,
} from '@heroicons/react/outline';
import {ButtonLink} from 'components/UI/ButtonLink/ButtonLink';
import {dSalesSetDetailItemFromRefundAC} from 'model/dashboardSales/dSalesActionCreators';
import {PopupPanelDashboard} from 'components/containers/dashboard/DashboardContentTable/PopupPanelDashboard';
import {
    PopupDetails as PopupDetailsSales
} from 'components/containers/dashboard/dataSales/popupContents/popupDetails';
import {logoutSagaAC,} from 'model/system/systemActionCreators';
import {getSalesByRefundId} from 'model/dashboardSales/dSalesAPI';
import {numberCurrencyFormat} from 'constants/convertToLocalCurrency';
import {LabelList} from 'components/UI/LabelList/LabelList';
import {Loader} from 'components/UI/Loader/Loader';
import {typeFullSalesItem} from "../../../../../../model/dashboardSales/dSalesReducer";
import { getRefundDetailsById} from "../../../../../../model/dashboardRefunds/dRefundsAPI";



// Type
export type typePopupDetails = {
    variant?: string
    setOpenPopup: React.Dispatch<React.SetStateAction<boolean>>
    crossLinkToSale?: boolean
}

// Component
export const PopupDetailsRefund: React.FC<typePopupDetails> = ({variant, setOpenPopup, crossLinkToSale}) => {
    const dispatch = useDispatch()
    const color = getColor(variant)

    // System
    const id = useSelector((state: { dRefunds: IdRefundsState }) => state.dRefunds.detailItem)?.id || null

    // get full data with products
    const [dataObject, setDataObjectFull] =
        useState<typeFullSalesItem | null>(null);

    const [loaderSales, setLoaderSales] = useState(false)

    useEffect(() => {
        const setData = async () => {
            if ( id ) {
                setLoaderSales(true);

                const response = await getRefundDetailsById({ refundId: id });

                if (response.status === 200) {
                    setDataObjectFull(response.data);
                }
            }
        };
        setData().finally(() => {
            setLoaderSales(false);
        });
        // eslint-disable-next-line
    }, []);

//PopupDetails for Sale
    const [openPopupDetailsSales, setOpenPopupDetailsSales] = React.useState(false)

    const btnLinkClickHandler = async (e: React.MouseEvent | React.TouchEvent, refundId: string) => {
        setLoaderSales(true)
        let refundItem = await getSalesByRefundId({refundId})

        if (refundItem.status === 200) {
            dispatch(dSalesSetDetailItemFromRefundAC(refundItem.data[0]))
        } else if (refundItem.status === 401) {
            dispatch(logoutSagaAC())
        }

        // dispatch(dSalesSetDetailItemFromRefundAC(dataObject!.sale))
        setOpenPopupDetailsSales(true)
        setLoaderSales(false)
    }


    let vat: number = 0

    if (dataObject) {


        if (dataObject!.productList.some(item => item.discountAmount !== 0)) {


            vat = dataObject.productList.reduce((acc, curr) => {

                const discountPercent = curr.discountAmount > 0 ? curr.discountAmount / (curr.customTotal ? curr.customTotal/curr.amount : curr.price) : 0
                const currVat = curr.tax !== null
                    ? curr.tax
                    : curr.product?.vat ? curr.product.vat : 0
                const currPrice = (curr.customTotal ? (curr.customTotal / curr.amount) : curr.price) * (1 - discountPercent)
                const vatForItem = (currVat * currPrice) / (1 + currVat)
                return acc + vatForItem * curr.amount
            }, 0)

        } else {
            vat = dataObject.productList.reduce((acc, curr) => {

                const currVat = curr.tax !== null
                    ? curr.tax
                    : curr.product?.vat ? curr.product.vat : 0
                const currPrice = (curr.customTotal ? (curr.customTotal / curr.amount) : curr.price) * (1 )
                const vatForItem = (currVat * currPrice) / (1 + currVat)
                return acc + vatForItem * curr.amount
            }, 0)
        }

    }

    return (
        <>
            { id
                ? <>
                    <div className="grid gap-x-8 grid-cols-1 sm:grid-cols-2 sm:border sm:rounded-md sm:px-4">
                        <div
                            className="flex  flex-wrap gap-x-4 py-2 border-t sm:border-t-0 border-b ">
                            <div className="text-gray-500 text-left"><Trans>Refunds Id:</Trans></div>
                            <div className="text-gray-900 text-left ">{id}</div>
                        </div>
                        <div
                            className="flex flex-wrap gap-x-4 py-2 border-b ">
                            <div className="text-gray-500 text-left"><Trans>Date</Trans>:</div>
                            <div
                                className="text-gray-900 text-left ">{dataObject?.date ? dataObject.date.substring(0, 19)
                                .replace('T', ' ') : '-'}</div>
                        </div>
                        <div className="flex flex-wrap gap-x-4 py-2 sm:py-4  border-b ">
                            <div className="flex gap-x-2 items-center text-gray-500 text-left">
                                <Trans>Z-report number: </Trans>
                            </div>
                            <div
                                className="text-gray-900 text-left">{dataObject?.zreportNumber ? dataObject.zreportNumber : '-'}</div>
                        </div>
                        <div className="flex flex-wrap gap-x-4 py-2 border-t-0   border-b ">
                            <div className="text-gray-500 text-left"><Trans>Refund amount:</Trans></div>
                            <div
                                className="text-gray-900 text-left ">{dataObject?.amount ? numberCurrencyFormat(+dataObject.amount) : '-'}</div>
                        </div>
                        <div
                            className="flex flex-wrap gap-x-4 py-2  border-b sm:border-b-0 ">
                            <div className="text-gray-500 text-left"><Trans>Receipt number</Trans>:</div>
                            <div
                                className="text-gray-900 text-left ">{dataObject?.receiptNumber ? dataObject.receiptNumber : ' - '}</div>
                        </div>
                        <div
                            className="flex flex-wrap gap-x-4 py-2 border-b sm:border-b-0 relative">
                            {crossLinkToSale &&
                                <>
                                    <div className="text-gray-500 text-left"><Trans>Sale</Trans>:</div>
                                    <div className="text-gray-900 text-left flex-grow divide-y">

                                        <p className="flex justify-end ">
                                            <ButtonLink type="button"
                                                        onClick={(e) => {
                                                            btnLinkClickHandler(e, dataObject!.id)
                                                        }}
                                                        buttonClassName={'py-1 px-2 mt-2  self-end'}
                                                        label={<Trans>Sale info</Trans>}
                                            />
                                        </p>
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                    <div
                        className="mt-5 sm:mt-2.5 grid gap-x-8 grid-cols-1 sm:grid-cols-2 sm:border sm:rounded-md sm:px-4">
                        {process.env.REACT_APP_CUSTOMER !== 'SKAPPSK' &&
                            <div className="flex flex-wrap gap-x-4 py-2  border-t sm:border-b-0 sm:border-t-0">
                                <div className="text-gray-500 text-left">
                                    <Trans>Fiscal module ID: </Trans>
                                </div>
                                <div
                                    className="text-gray-900 text-left">{dataObject?.fmId ? dataObject.fmId : '-'}</div>
                            </div>
                        }

                        {/*{process.env.REACT_APP_CUSTOMER !== 'SKAPPSK' && <div*/
                        }
                        {/*    className="flex flex-wrap gap-x-4 py-2  border-t border-b  sm:border-t-0">*/
                        }
                        {/*    <div className=" text-gray-500 text-left">*/
                        }
                        {/*        <Trans>Fiscal sign</Trans>:*/
                        }
                        {/*    </div>*/
                        }
                        {/*    <div*/
                        }
                        {/*        className="text-gray-900 text-left">{ dataObject.fiscalSign ? dataObject.fiscalSign : '-' }</div>*/
                        }
                        {/*</div> }*/
                        }

                        <div className="flex flex-wrap gap-x-4 py-2 border-b  sm:border-0">
                            <div className="flex gap-x-2 items-center text-gray-500 text-left">
                                <Trans>Applet version</Trans>:
                            </div>
                            <div
                                className="text-gray-900 text-left">{dataObject?.appletVersion ? dataObject.appletVersion : '-'}</div>
                        </div>
                    </div>
                    <div
                        className="mt-5 sm:mt-2.5 grid gap-x-8 grid-cols-1 sm:grid-cols-2 sm:border sm:rounded-md sm:px-4">


                        <div className="flex flex-wrap gap-x-4 py-2  border-b sm:border-b-0">
                            <div className="flex gap-x-2 items-center text-gray-500 text-left">
                                <Trans>User name: </Trans>
                            </div>
                            <div
                                className=" text-left text-gray-900 ">{dataObject?.userName ? dataObject.userName : '-'}</div>
                        </div>

                        <div className="flex flex-wrap gap-x-4 py-2  border-b sm:border-b-0">
                            <div className="flex gap-x-2 items-center text-gray-500 text-left">
                                <Trans>Store:</Trans>
                            </div>
                            <div
                                className=" text-left text-gray-900 ">{dataObject?.store?.name ? dataObject.store.name : '-'}</div>
                        </div>
                    </div>
                    <div
                        className="mt-4 sm:mt-2.5 py-1.5  grid gap-x-8 grid-cols-1  sm:border sm:rounded-md sm:px-4 overflow-x-auto">
            <span className="flex gap-x-1 font-medium py-1 mb-1.5">
            <span className="text-gray-400"><ClipboardListIcon className="h-6 w-6"/></span>
            <Trans>Refund list</Trans>
            </span>
                        {loaderSales && <Loader/>}
                        <table className="min-w-full divide-y divide-gray-200 border-t">
                            <thead className="bg-gray-50">
                            <tr className="relative">
                                <th scope="col"
                                    className="px-3 py-2  text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    <Trans>Product ID</Trans>
                                </th>
                                <th scope="col"
                                    className="px-3 py-2  text-left text-xs font-medium text-gray-500 uppercase tracking-wider ">
                                    <Trans>Name</Trans>
                                </th>
                                <th scope="col"
                                    className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider ">
                                    <Trans>Label</Trans>
                                </th>
                                <th scope="col"
                                    className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider ">
                                    <Trans>Count</Trans>
                                </th>
                                <th scope="col"
                                    className="px-3 py-2  text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    <Trans>Price for unit</Trans>
                                </th>
                                {process.env.REACT_APP_CUSTOMER !== 'SKAPPSK' && <th scope="col"
                                                                                     className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider ">
                                    <Trans>VAT</Trans>
                                </th>}
                                <th scope="col"
                                    className="px-3 py-2  text-left text-xs font-medium text-gray-500 uppercase tracking-wider ">
                                    <Trans>Discount</Trans>
                                </th>
                                <th scope="col"
                                    className="px-3 py-2  text-left text-xs font-medium text-gray-500 uppercase tracking-wider ">
                                    <Trans>Total price</Trans>
                                </th>
                            </tr>
                            </thead>
                            <tbody className="divide-y">
                            {dataObject?.productList.length ? dataObject.productList.map((item, index) => {
                                let tax;
                                if ('tax' in item && item.tax !== null) {
                                    tax = item.tax
                                } else if ('vat' in item.product) {
                                    tax = item.product.vat
                                } else {
                                    tax = 0
                                }
                                return <tr key={index} className={` bg-white hover:bg-${color}-50  align-top`}>

                                    <td className="px-3 py-2 whitespace-nowrap text-xs  text-gray-500 ">{item.product.id}</td>
                                    <td className="px-3 py-2 whitespace-nowrap text-sm   text-gray-900 "> {item.productName || item.product.name}</td>
                                    <td className="px-3 py-2 whitespace-nowrap text-sm  text-gray-500 ">
                                        <LabelList labelsList={item.markedLabels}/>
                                    </td>
                                    <td className="px-3 py-2 whitespace-nowrap text-sm  text-gray-500 ">{item?.amount ? item.amount : ' - '}</td>
                                    <td className="px-3 py-2 whitespace-nowrap text-sm  text-gray-500 ">{item?.price ? numberCurrencyFormat(item.price) : ' - '}</td>
                                    {process.env.REACT_APP_CUSTOMER !== 'SKAPPSK' && <td
                                        className="px-3 py-2 whitespace-nowrap text-sm  text-gray-500 ">{(tax * 100).toLocaleString(undefined, {maximumFractionDigits: 2})}%</td>}
                                    <td className="px-3 py-2 whitespace-nowrap text-sm  text-gray-500 ">{numberCurrencyFormat(+(item.discountAmount).toFixed(2))}</td>
                                    <td className="px-3 py-2 whitespace-nowrap text-sm  text-gray-500 ">{ numberCurrencyFormat(+(item.amount * item.price -( item.discountAmount || 0)).toFixed(2))}</td>
                                </tr>
                            }) : (<tr>
                                <td className="px-3 py-2  whitespace-nowrap text-sm  text-gray-500 col-span-9"
                                ><Trans>Have no data.</Trans>
                                </td>
                            </tr>)}
                            {process.env.REACT_APP_CUSTOMER !== 'SKAPPSK' && <tr>
                                <td colSpan={7}
                                    className="px-3 py-2 whitespace-nowrap text-xs  text-gray-500 col-span-4 text-left">
                                    <Trans>VAT including</Trans>:
                                </td>
                                <td className="px-3 py-2 whitespace-nowrap text-sm   text-gray-500 "> {numberCurrencyFormat(vat)}</td>
                            </tr>}
                            <tr>
                                <td colSpan={process.env.REACT_APP_CUSTOMER === 'SKAPPSK' ? 6 : 7}
                                    className="px-3 py-2 whitespace-nowrap text-xs  text-gray-900 col-span-4 text-left">
                                    <Trans>Total</Trans>:
                                </td>
                                <td className="px-3 py-2 whitespace-nowrap text-sm   text-gray-900 "> {dataObject?.amount ? numberCurrencyFormat(+dataObject.amount): "-"}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="flex gap-4 mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                        <Button type="button" secondary={true} label={<Trans>Close</Trans>}
                                onClick={() => setOpenPopup(false)}/>
                    </div>
                </>
                :
                <Alert type="error" title={<Trans>Have no data.</Trans>}/>
            }
            {/* Popup Details Refunds dialog */
            }
            <PopupPanelDashboard
                title={<Trans>Fool sale information</Trans>}
                openPopup={openPopupDetailsSales}
                setOpenPopup={setOpenPopupDetailsSales}
            >
                <PopupDetailsSales setOpenPopup={setOpenPopupDetailsSales} crossLinkToRefund={false}/>
            </PopupPanelDashboard>
        </>
    )
}
